import FormCaseGroupAssignment from "../components/ui/form-case-group-assignment.js";
import CurrentCaseRequired from "../components/ui/current-case-required.js";
// import CaseDatabaseCheck from "../components/ui/case-database-check.js";

export default function ManageCaseGroupAssignmentPage() {

  return (

    <CurrentCaseRequired>
      <FormCaseGroupAssignment/>
    </CurrentCaseRequired>

  );
}